"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destinationCodeValidate = exports.NUMBER_OF_MAXIMUM_RECIPIENT_CODE_CHAR = void 0;
exports.NUMBER_OF_MAXIMUM_RECIPIENT_CODE_CHAR = 13;
var destinationCodeValidate = function (tenantDestinationCode, destinationCode) {
    return (destinationCode.length <= exports.NUMBER_OF_MAXIMUM_RECIPIENT_CODE_CHAR - tenantDestinationCode.length &&
        /^[0-9]*$/.test(destinationCode));
};
exports.destinationCodeValidate = destinationCodeValidate;
